var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group-item",class:{ active: _vm.selectedItemId === _vm.item.id, 'bg-warning': _vm.selectedItemId === _vm.item.id }},[_c('span',{directives:[{name:"handle",rawName:"v-handle"}],staticClass:"fa fa-exchange fa-rotate-90 handle mr-2"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }